import { IUser } from 'common/src/types/interfaces';

import UserForm from 'portal/src/components/systemAdministration/Form/User/UserForm';
import { FormComponentType } from 'portal/src/layouts/base/FormComponentType';

const SystemAdministrationUserForm: FormComponentType = ({
  entity,
  handleBackAction,
}: {
  entity?: IUser;
  handleBackAction: () => void;
}) => (
  <UserForm
    entity={entity}
    handleBackAction={handleBackAction}
    orgFieldDisabled={false}
  />
);

export default SystemAdministrationUserForm;
